import {
  FieldValues,
  Path,
  UseControllerProps,
  useController,
} from "react-hook-form";

export type UseFieldProps<TForm extends FieldValues> =
  UseControllerProps<TForm>;

export function useField<TValue, TForm extends FieldValues>(
  props: UseFieldProps<TForm>
) {
  const {
    field: { value, ...restField },
    fieldState,
    formState,
  } = useController(props);

  const val: TValue = value;

  return { field: { value: val, ...restField }, fieldState, formState };
}
